var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCompleteNonCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#DDDDE3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.0293 9.37571C4.06163 9.6667 4.70731 10.1318 4.92565 10.3034C5.44651 10.7127 5.87254 11.3255 6.34226 11.7952C6.8774 12.3304 7.39138 12.9474 7.81215 13.5785C8.10196 14.0132 8.2699 13.5766 8.53613 13.2808C8.86751 12.9126 9.23282 12.4697 9.62052 12.1651C10.2923 11.6373 10.8139 10.9063 11.4508 10.3473C11.8441 10.0022 12.1833 9.60169 12.5916 9.26288C13.0349 8.89505 13.406 8.44496 13.8014 8.03432C14.2418 7.57697 14.6554 7.0845 15.0989 6.62397C15.2338 6.48393 15.3735 6.24417 15.5377 6.14759C15.7255 6.03714 15.7954 5.74921 15.989 5.6524",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCompleteNonCheck);
export default __webpack_public_path__ + "static/media/icon-complete-non-check.22426212c13feba36f66b1dc301f60c5.svg";
export { ForwardRef as ReactComponent };